import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  open() {
    if (!this.hasModalTarget) return
    this.modalTarget.hidden = false
    this.modalTarget.querySelector("button")?.focus()
    document.body.classList.add("public-modal-open")
  }

  close() {
    if (!this.hasModalTarget) return
    this.modalTarget.hidden = true
    document.body.classList.remove("public-modal-open")
  }
}
